import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ExecutionQ, ExecutionStatus } from '../../../../model/execution';
import { ProtocolQ } from '../../../../model/protocol';
import { ExecutionReportFilter } from '../../../../model/attachment';
import { LangFlag, TranslationService } from '../../../../services/translation.service';
import { Subject, takeUntil } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ExecutionQService } from '../../../../services/executionQ.service';
import { SpinnerService } from '../../../../services/spinner.service';
import { SnackBarService } from '../../../../services/snackBar.service';
import { StringUtils } from '../../../../utils/stringUtils';
import { saveAs } from 'file-saver';
import { MatRadioChange } from '@angular/material/radio';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FileUtils } from '../../../../utils/fileUtils';
import { ExecutionUtils } from '../../../../utils/executionUtils';

export interface DialogDataGenerateReport {
  execution: ExecutionQ;
  protocol: ProtocolQ;
  reason: string;
  toSign: boolean;
  config: ExecutionReportFilter;
  isForAutomaticSign: boolean;
}

@Component({
    selector: 'app-execution-q-edit-generate-report',
    templateUrl: './execution-q-edit-generate-report.component.html',
    styleUrl: './execution-q-edit-generate-report.component.scss',
    standalone: false,
})
export class ExecutionQEditGenerateReportComponent implements OnInit, OnDestroy {

  optionsToDownload: string[] = [];
  optionsConfigReport: string[] = [];
  optionSelected: string;

  reportConfig: ExecutionReportFilter;

  langs: LangFlag[];

  changeConclusions: boolean;

  private destroy$ = new Subject<void>();
  constructor(
    public dialog: MatDialog, public dialogRef: MatDialogRef<ExecutionQEditGenerateReportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogDataGenerateReport, private executionService: ExecutionQService,
    private translate: TranslateService, private translationService: TranslationService,
    public snackBarService: SnackBarService, private spinnerService: SpinnerService) {
  }

  ngOnInit(): void {
    if (this.data.config == null) {
      this.reportConfig = new ExecutionReportFilter();
      this.reportConfig.lang = this.translationService.currentLang;
    } else {
      this.reportConfig = this.data.config;
    }

    this.reportConfig.conclusions = this.data.execution.conclusions;
    this.changeConclusions = StringUtils.isNotEmpty(this.data.execution.conclusions);

    this.langs = this.translationService.configuredLangs;

    this.optionsToDownload.push('report');

    this.optionsConfigReport.push('report');

    this.optionSelected = 'report';

    if (this.data.execution.idStatus === ExecutionStatus.FIRMADO) {
      this.spinnerService.show();

      this.executionService.downloadPdfExecutionVersion(this.data.execution).pipe(takeUntil(this.destroy$)).subscribe((res: Blob) => {
        const name = ExecutionUtils.getNameExecutionQForReportPdf(this.data.execution, this.translate);
        saveAs(res, name);
        this.spinnerService.hide();

        this.dialogRef.close();
      }, () => {
        this.snackBarService.sendError(this.translate.instant('executionEdit.form.downloadPdf.error.notFound') as string);
        this.spinnerService.hide();
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showConfigReport(): boolean {
    return true; //this.optionsConfigReport.includes(this.optionSelected);
  }

  showChangeLangIcon(): boolean {
    return this.langs.length > 1;
  }

  onOptionChange(event: MatRadioChange): void {
    this.optionSelected = event.value as string;
  }

  onChangeConclusionsCheck(event: MatCheckboxChange): void {
    this.changeConclusions = event.checked;

    if (event.checked && StringUtils.isEmpty(this.reportConfig.conclusions)) {
      this.reloadConclusions();
    }
  }

  reloadConclusions(): void {
    this.spinnerService.show();

    this.executionService.getConclusions(this.data.execution.id, this.reportConfig.lang).pipe(takeUntil(this.destroy$)).subscribe(con => {
      this.reportConfig.conclusions = con.conclusions as string;
      this.spinnerService.hide();
    });
  }

  onOkClick(hybride: boolean): void {
    this.reportConfig.hybride = hybride;
    this.reportConfig.toSign = this.data.toSign;

    if (!this.changeConclusions) {
      this.reportConfig.conclusions = null;
    }

    if (this.data.reason) {
      this.reportConfig.reason = this.data.reason;
    }

    if (this.data.isForAutomaticSign) {
      this.dialogRef.close(this.reportConfig);
    } else {
      this.defaultActionReport();
    }
    

    /*this.executionService.checkForDownload(this.data.execution.id).pipe(takeUntil(this.destroy$)).subscribe((errors: string[]) => {

      if (errors != null && errors.length > 0) {
        this.spinnerService.hide();

        this.snackBarService.sendError(errors.join('\n'));

        return;
      }

      
    }, err => {
      if (err != null && err.error != null && typeof err.error === 'string') {
        this.snackBarService.sendError(err.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('executionEdit.form.downloadPdf.error.generic') as string);
      }

      this.spinnerService.hide();
    });*/
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  defaultActionReport(): void {
    this.spinnerService.show();
    this.executionService.downloadPdf(this.data.execution.id, this.reportConfig).pipe(takeUntil(this.destroy$)).subscribe(err => {

      if (err != null && err.error != null && typeof err.error === 'string') {
        this.snackBarService.sendError(err.error as string);
        this.spinnerService.hide();

      } else if (err.errors) {
        const error = err.errors.join('\n') as string;
        this.snackBarService.sendError(error);
        this.spinnerService.hide();
      } else if (err.file) {
        const name = ExecutionUtils.getNameExecutionQForReportPdf(this.data.execution, this.translate);
        saveAs(FileUtils.base64toBlob(err.file.contentString, err.file.contentType as string), name);
        this.spinnerService.hide();
      }

      this.dialogRef.close(this.reportConfig);
    }, err => {
      console.error(err);

      if (err != null && err.error != null && typeof err.error === 'string') {
        this.snackBarService.sendError(err.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('executionEdit.form.downloadPdf.error.generic') as string);
      }

      this.spinnerService.hide();
    });
  }
}
